import { Box, CircularProgress, Tooltip, Button } from '@mui/material';
import { Clear, Save } from '@mui/icons-material';
import { colors, cssColorLight } from '../constants/globalcss';
import { sizes } from '../styles/commonStyles';

interface FormButtonGroupProps {
  onClear: () => void;
  submitting?: boolean;
  disableSubmit?: boolean;
  submitTooltip?: string;
  sx?: any;
  onSubmit?: () => void;
  clearButtonText?: string;
}

const FormButtonGroup: React.FC<FormButtonGroupProps> = ({
  onClear,
  submitting = false,
  disableSubmit = false,
  submitTooltip,
  sx,
  onSubmit,
  clearButtonText,
}) => (
  <Box
    sx={{
      display: 'flex',
      gap: 2,
      justifyContent: 'center',
      ...sx,
    }}
  >
    <Button
      onClick={onClear}
      disabled={submitting}
      variant="outlined"
      startIcon={<Clear />}
      sx={{
        borderColor: colors.primary,
        borderRadius: sizes.borderRadius.medium,
        color: colors.primary,
        fontWeight: sizes.fontWeight.semiBold,
        letterSpacing: sizes.letterSpacing.wide,
        minWidth: sizes.dimensions.minButtonWidth,
        padding: `${sizes.spacing.md} ${sizes.spacing.lg}`,
        textTransform: 'uppercase',
      }}
    >
      {clearButtonText || 'Clear'}
    </Button>

    <Tooltip
      title={submitTooltip || ''}
      arrow
      disableHoverListener={!submitTooltip}
    >
      <span>
        <Button
          type="submit"
          disabled={submitting || disableSubmit}
          variant="contained"
          startIcon={
            submitting ? (
              <CircularProgress
                size={20}
                sx={{ color: colors.background.paper }}
              />
            ) : (
              <Save />
            )
          }
          onClick={onSubmit}
          sx={{
            '&:hover': {
              backgroundColor: cssColorLight,
            },
            backgroundColor: colors.primary,
            borderRadius: sizes.borderRadius.medium,
            color: colors.background.paper,
            fontWeight: sizes.fontWeight.semiBold,
            letterSpacing: sizes.letterSpacing.wide,
            minWidth: sizes.dimensions.minButtonWidth,
            padding: `${sizes.spacing.md} ${sizes.spacing.lg}`,
            textTransform: 'uppercase',
          }}
        >
          {submitting ? 'Submitting...' : 'Submit'}
        </Button>
      </span>
    </Tooltip>
  </Box>
);

export default FormButtonGroup;
